import { render, staticRenderFns } from "./PasswordChangeDialog.vue?vue&type=template&id=653e789f"
import script from "./PasswordChangeDialog.vue?vue&type=script&lang=js"
export * from "./PasswordChangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports